import React, { ReactNode } from 'react';
import { ToastContainer as ReactToastifyContainer, toast, ToastContent, ToastOptions } from 'react-toastify';

type NotificationMessage = ToastContent<unknown> | ReactNode;
type NotificationCallback = () => void;
type NotificationType = 'success' | 'warning' | 'error' | 'info';

const createNotification = (
  type: NotificationType,
  message: NotificationMessage,
  title = '',
  timeout = 2000,
  callback?: NotificationCallback,
) => {
  const content = title ? (
    <>
      <strong>{title}</strong>
      <div>{message as ReactNode}</div>
    </>
  ) : (
    message
  );

  const options: ToastOptions = {
    autoClose: false,
    className: title ? `legacy-notification-toast legacy-notification-toast--${type}` : 'legacy-notification-toast',
    closeButton: false,
    closeOnClick: false,
    icon: false,
    onClose: callback,
    pauseOnFocusLoss: false,
    pauseOnHover: false,
  };

  const toastId = toast[type](content, options);

  if (timeout > 0) {
    window.setTimeout(() => toast.dismiss(toastId), timeout);
  }
};

export const NotificationManager = {
  success: (message: NotificationMessage, title?: string, timeout?: number, callback?: NotificationCallback) =>
    createNotification('success', message, title, timeout, callback),
  warning: (message: NotificationMessage, title?: string, timeout?: number, callback?: NotificationCallback) =>
    createNotification('warning', message, title, timeout, callback),
  error: (message: NotificationMessage, title?: string, timeout?: number, callback?: NotificationCallback) =>
    createNotification('error', message, title, timeout, callback),
  info: (message: NotificationMessage, title?: string, timeout?: number, callback?: NotificationCallback) =>
    createNotification('info', message, title, timeout, callback),
};

export const NotificationContainer = () => (
  <ReactToastifyContainer pauseOnFocusLoss={false} pauseOnHover={false} position="top-right" />
);
